import PropTypes from 'prop-types';
import { useState } from 'react';
// mui
import { Stack, Typography, Grid, RadioGroup, Radio, FormControl, FormControlLabel, Checkbox, Select, MenuItem, InputLabel } from '@mui/material';
import { GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid';
// components
import GridToolbarMultipleDelete from '../../sections/master/customToolbar/GridToolbarMultipleDelete';
import ExportToExcelButton from '../exporttoexcelbutton';
import AppCache from '../../services/appcache';
// --------------------------------------------------------------------------------------------------------

CustomGridToolbar.propTypes = {
    rows: PropTypes.array,
    records: PropTypes.string,
    lastUpdate: PropTypes.string,
    selectedForDelete: PropTypes.number,
    rowIndex: PropTypes.array,
    masterName: PropTypes.string,
    cl: PropTypes.string,
    contentList: PropTypes.array,
    handleChange: PropTypes.func,
    handleFranchise: PropTypes.func,
    franchise: PropTypes.string,
    franchiseData: PropTypes.array,
    unmapped: PropTypes.bool,
    isChecked: PropTypes.bool,
    handleCheckboxChange: PropTypes.func,
    filterData: PropTypes.array,
    returnFilterData: PropTypes.array,
    handleFilterChange: PropTypes.func,
    handleReturnFilterChange: PropTypes.func,
    filterValue: PropTypes.string,
    returnFilterValue: PropTypes.string,
    columnData: PropTypes.array,
    invMsg: PropTypes.string,
};
// ----------------------------------------------------------------------------------------------------------------

export default function CustomGridToolbar({ rows, records, lastUpdate, selectedForDelete, rowIndex, masterName,
    cl, contentList, handleChange, franchiseData, franchise, handleFranchise, unmapped, isChecked, handleCheckboxChange,
    filterData, filterValue, handleFilterChange, returnFilterData, handleReturnFilterChange, returnFilterValue,
    invMsg, columnData }) {

    const currentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userRole = currentLoggedInUser.UserRoleName;

    const [quickFilterValue, setQuickFilterValue] = useState('');

    const calculateNewMasterName = (value) => value.toUpperCase();

    const handleQuickFilterChange = (event) => {
        const value = event.target.value;
        setQuickFilterValue(value);
        const newMasterName = calculateNewMasterName(value);
        handleChange(newMasterName);
    };

    return (
        <GridToolbarContainer>
            <Grid container>
                <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }}
                    justifyContent={{ xs: 'flex-start', md: 'space-between' }} flexGrow={1} spacing={1}>
                    <Grid item xs={12} md={6}>
                        <Stack direction='row' alignItems='center' justifyContent='flex-start' spacing={1}>
                            {records &&
                                <Grid item md={5.5}>
                                    <Typography variant='subtitle2' fontSize={14} sx={{ pl: 1 }}>
                                        {records}
                                    </Typography>
                                </Grid>
                            }
                            {invMsg &&
                                <Grid item md={5.5}>
                                    <Typography variant='subtitle2' fontSize={12} sx={{ pl: 1, color: 'error.main' }}>
                                        {invMsg}
                                    </Typography>
                                </Grid>
                            }
                            {unmapped &&
                                <Grid item md={5}>
                                    <FormControlLabel
                                        checked={isChecked}
                                        onChange={handleCheckboxChange}
                                        control={<Checkbox />}
                                        label={
                                            <Typography variant="subtitle2">
                                                Unmapped Data
                                            </Typography>
                                        }
                                    />
                                </Grid>
                            }
                            {lastUpdate &&
                                <Grid item md={5}>
                                    <Typography variant='caption'>
                                        Last updated on {lastUpdate}
                                    </Typography>
                                </Grid>
                            }
                            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'flex-start', sm: 'center' }}
                                justifyContent={{ xs: 'flex-start', sm: 'space-between' }} flexGrow={1} spacing={1}>
                                {contentList &&
                                    <Grid item xs={12} md={10}>
                                        <FormControl sx={{ pl: 1 }}>
                                            <RadioGroup row
                                                //  value={cl}
                                                defaultValue={cl}
                                                onChange={handleChange}>
                                                {contentList.map((content) => (
                                                    <FormControlLabel
                                                        key={content.id}
                                                        value={content.id}
                                                        control={<Radio />}
                                                        label={content.name}
                                                    />
                                                ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                }
                                {franchiseData &&
                                    <Grid item xs={12} sm={5}>
                                        <FormControl fullWidth>
                                            <InputLabel>Franchise</InputLabel>
                                            <Select name="franchise" label="Franchise" size='small' fullWidth
                                                className="ReportFilters" value={franchise} onChange={handleFranchise}>
                                                {franchiseData.map((data) => (
                                                    <MenuItem key={data.franchise} value={data.franchise}>
                                                        {data.franchise}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                }
                                {filterData &&
                                    <Grid item xs={12} sm={5}>
                                        <Select name="filter" label="Filters" size='small' fullWidth
                                            value={filterValue} onChange={handleFilterChange}>
                                            {filterData.map((data) => (
                                                <MenuItem key={data.name} value={data.name}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                }
                                {returnFilterData &&
                                    <Grid item xs={12} sm={4}>
                                        <Select name="filter" label="Filters" size='small' fullWidth
                                            value={returnFilterValue} onChange={handleReturnFilterChange}>
                                            {returnFilterData.map((data) => (
                                                <MenuItem key={data.name} value={data.name}>
                                                    {data.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid>
                                }
                            </Stack>
                        </Stack>
                    </Grid>
                    <Stack direction='row' alignItems="center" justifyContent="flex-end" spacing={1}>
                        <GridToolbarQuickFilter variant='outlined' size='small' />
                        <GridToolbarFilterButton value={quickFilterValue}
                            onChange={handleQuickFilterChange} />
                        {/* <GridToolbarExport printOptions={{ disableToolbarButton: true }} csvOptions={{ utf8WithBom: true, }} />  */}
                        <ExportToExcelButton rowData={rows} columnData={columnData} />
                    </Stack>
                </Stack>
            </Grid>
            {(rowIndex && userRole !== 'J&J Sales' && userRole !== 'NSM Viewer' && userRole !== 'RSM Viewer') &&
                <GridToolbarMultipleDelete numSelected={selectedForDelete} masterName={masterName}
                    rowIndex={rowIndex} rowData={rows} />
            }
        </GridToolbarContainer>
    );
}